import { useFormik } from "formik";
import React, { useState } from "react";
import { injectIntl } from "react-intl";
import { connect } from "react-redux";
import { Link } from "react-router-dom";
import * as Yup from "yup";
import { requestPassword } from "../_redux/authCrud";
import * as auth from "../_redux/authRedux";

const initialValues = {
  userName: "",
};

function ForgotPassword(props) {
  const { intl } = props;
  const [isRequested, setIsRequested] = useState(false);
  const ForgotPasswordSchema = Yup.object().shape({
    userName: Yup.string()
      .min(
        1,
        intl.formatMessage(
          {
            id: "AUTH.VALIDATION.MIN_LENGTH",
            defaultMessage: "AUTH.VALIDATION.MIN_LENGTH",
          },
          {
            name: intl.formatMessage({
              id: "AUTH.INPUT.USERNAME",
              defaultMessage: "AUTH.INPUT.USERNAME",
            }),
            min: "1",
          }
        )
      )
      .max(
        30,
        intl.formatMessage(
          {
            id: "AUTH.VALIDATION.MAX_LENGTH",
            defaultMessage: "AUTH.VALIDATION.MAX_LENGTH",
          },
          {
            name: intl.formatMessage({
              id: "AUTH.INPUT.USERNAME",
              defaultMessage: "AUTH.INPUT.USERNAME",
            }),
            max: "30",
          }
        )
      )
      .required(
        intl.formatMessage({
          id: "VALIDATION.REQUIRED_FIELD",
          defaultMessage: "VALIDATION.REQUIRED_FIELD",
        })
      ),
  });

  const getInputClasses = (fieldname) => {
    if (formik.touched[fieldname] && formik.errors[fieldname]) {
      return "is-invalid";
    }

    if (formik.touched[fieldname] && !formik.errors[fieldname]) {
      return "is-valid";
    }

    return "";
  };

  const formik = useFormik({
    initialValues,
    validationSchema: ForgotPasswordSchema,
    onSubmit: (values, { setStatus, setSubmitting }) => {
      requestPassword(values.userName)
        .then(() => setIsRequested(true))
        .catch(() => {
          setIsRequested(false);
          setSubmitting(false);
        });
    },
  });

  return (
    <>
      <div className="login-form login-forgot" style={{ display: "block" }}>
        <div className="text-center mb-10 mb-lg-20">
          <h3 className="font-size-h1">
            {intl.formatMessage({
              id: "AUTH.FORGOT.TITLE",
              defaultMessage: "AUTH.FORGOT.TITLE",
            })}
          </h3>
          <div className="text-muted font-weight-bold">
            {intl.formatMessage({
              id: "AUTH.FORGOT.DESC",
              defaultMessage: "AUTH.FORGOT.DESC",
            })}
          </div>
        </div>
        {!isRequested && (
          <form
            onSubmit={formik.handleSubmit}
            className="form fv-plugins-bootstrap fv-plugins-framework animated animate__animated animate__backInUp"
          >
            {formik.status && (
              <div className="mb-10 alert alert-custom alert-light-danger alert-dismissible">
                <div className="alert-text font-weight-bold">
                  {formik.status}
                </div>
              </div>
            )}
            <div className="form-group fv-plugins-icon-container">
              <input
                placeholder={intl.formatMessage({
                  id: "AUTH.INPUT.USERNAME",
                  defaultMessage: "AUTH.INPUT.USERNAME",
                })}
                className={`form-control form-control-solid h-auto py-5 px-6 ${getInputClasses(
                  "userName"
                )}`}
                name="userName"
                {...formik.getFieldProps("userName")}
              />
              {formik.touched.userName && formik.errors.userName ? (
                <div className="fv-plugins-message-container">
                  <div className="fv-help-block">{formik.errors.userName}</div>
                </div>
              ) : null}
            </div>
            <div className="form-group d-flex flex-wrap flex-center">
              <button
                id="kt_login_forgot_submit"
                type="submit"
                className="btn btn-primary font-weight-bold px-9 py-4 my-3 mx-4"
                disabled={formik.isSubmitting}
              >
                {intl.formatMessage({
                  id: "AUTH.GENERAL.SUBMIT_BUTTON",
                  defaultMessage: "AUTH.GENERAL.SUBMIT_BUTTON",
                })}
              </button>
              <Link to="/auth">
                <button
                  type="button"
                  id="kt_login_forgot_cancel"
                  className="btn btn-light-primary font-weight-bold px-9 py-4 my-3 mx-4"
                >
                  {intl.formatMessage({
                    id: "COMMON.GENERAL.CANCEL_BUTTON",
                    defaultMessage: "COMMON.GENERAL.CANCEL_BUTTON",
                  })}
                </button>
              </Link>
            </div>
          </form>
        )}
        {isRequested && (
          <div className="text-center mb-10 mb-lg-20">
            <div className="mb-10 alert alert-custom alert-light-success alert-dismissible">
              <div className="alert-text font-weight-bold">
                {intl.formatMessage({
                  id: "AUTH.FORGOT.RESPONSE",
                  defaultMessage: "AUTH.FORGOT.RESPONSE",
                })}
              </div>
            </div>
            <Link to="/auth">
              <button
                type="button"
                id="login"
                className="btn btn-light-primary font-weight-bold px-9 py-4 my-3 mx-4"
              >
                Login
              </button>
            </Link>
          </div>
        )}
      </div>
    </>
  );
}

export default injectIntl(connect(null, auth.actions)(ForgotPassword));
